import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate';

export default function Drop() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState([])
    const [pageNumber, setPageNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState('');

    const Allchallenge = (page = pageNumber, lim = limit, q = search) => {
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        let url = baseUrl + `challange/drop_challange?page=${page}&_limit=${lim}`;
        if (q) url += `&_q=${encodeURIComponent(q)}&_stype=Name`;
        axios.get(url, { headers })
            .then((res) => {
                setchallenge(res.data.status || [])
                setTotalPages(res.data.totalPages || 0);
                setPageNumber(page);
                setLimit(lim);
                setSearch(q);
            })
            .catch(err => console.log(err))
    }

    // Per-row bonus/type inputs are uncontrolled (read directly by id on click) rather than
    // shared component state - previously a single `bonus`/`type` state was shared across ALL
    // rows, so editing one row's fields affected whichever row's UPDATE button was clicked next.
    const update = (id) => {
        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }
        const type = document.getElementById(`drop-type-${id}`).value;
        const bonus = document.getElementById(`drop-bonus-${id}`).value;
        const actionText = type === "running" ? "running" : "cancel";

        if (window.confirm(`Are you sure you want to set this game to ${actionText}?`)) {
            const endpoint = type === "running" ? `challenge/runningon/${id}` : `challenge/cancelledon/${id}`;
            axios.post(baseUrl + endpoint, { bonus: JSON.parse(bonus) }, { headers })
                .then(() => {
                    alert("Status updated successfully!");
                    Allchallenge();
                });
        }
    }

    const dateFormat = (e) => {
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        Allchallenge(0, limit, '')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // --- PREMIUM INLINE STYLES ---
    const thStyle = { background: '#f8f9fa', color: '#333', padding: '15px', fontWeight: '800', textAlign: 'center', borderBottom: '2px solid #ddd', whiteSpace: 'nowrap' };
    const tdStyle = { color: '#000000', fontWeight: '600', padding: '12px', textAlign: 'center', borderBottom: '1px solid #eee', background: '#fff', verticalAlign: 'middle' };
    const inputStyle = { border: '1px solid #ccc', borderRadius: '4px', padding: '5px', width: '80px', color: '#000', fontWeight: 'bold' };
    const selectStyle = { border: '1px solid #ccc', borderRadius: '4px', padding: '5px', color: '#000', fontWeight: 'bold', cursor: 'pointer' };

    if (challenge === undefined) return null;

    return (
        <div style={{ background: '#f0f2f5', minHeight: '100vh', padding: '15px', fontFamily: 'Poppins, sans-serif' }}>
            {/* Header Card */}
            <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', marginBottom: '20px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                <h4 style={{ margin: 0, color: '#d63031', fontWeight: '900' }}>💧 DROP CHALLANGES</h4>
                <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '0.85rem' }}>Management of dropped or stuck challenges</p>
            </div>

            <div style={{ background: '#fff', padding: '15px 20px', borderRadius: '15px', marginBottom: '20px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
                <input
                    type="text"
                    placeholder="Search by player name..."
                    defaultValue={search}
                    onKeyDown={(e) => { if (e.key === 'Enter') Allchallenge(0, limit, e.target.value); }}
                    style={{ flex: '1 1 220px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
                <select value={limit} onChange={(e) => Allchallenge(0, e.target.value, search)} style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd' }}>
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="50">Show 50</option>
                    <option value="100">Show 100</option>
                </select>
            </div>

            {/* Table Container */}
            <div style={{ background: '#fff', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1100px' }}>
                        <thead>
                            <tr>
                                <th style={thStyle}>#</th>
                                <th style={thStyle}>ID</th>
                                <th style={thStyle}>Creator (Name | Phone)</th>
                                <th style={thStyle}>Accepter (Name | Phone)</th>
                                <th style={thStyle}>Amount</th>
                                <th style={thStyle}>Status</th>
                                <th style={thStyle}>Quick Action Panel</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge.length > 0 ? (
                                challenge.map((game, index) => (
                                    <tr key={game._id}>
                                        <td style={tdStyle}>{(pageNumber > 0 ? (pageNumber - 1) * limit : 0) + index + 1}</td>
                                        <td style={{ ...tdStyle, color: '#0984e3', fontSize: '11px', fontFamily: 'monospace' }}>{game._id}</td>
                                        <td style={tdStyle}>
                                            <div style={{ color: '#57155a', fontWeight: 'bold' }}>{game.Created_by?.Name}</div>
                                            <div style={{ fontSize: '11px', color: '#666' }}>{game.Created_by?.Phone}</div>
                                        </td>
                                        <td style={tdStyle}>
                                            <div style={{ color: '#0369a1', fontWeight: 'bold' }}>{game.Accepetd_By?.Name || '---'}</div>
                                            <div style={{ fontSize: '11px', color: '#666' }}>{game.Accepetd_By?.Phone || '---'}</div>
                                        </td>
                                        <td style={{ ...tdStyle, color: '#27ae60', fontSize: '1.1rem' }}>₹{game.Game_Ammount}</td>
                                        <td style={tdStyle}>
                                            <span style={{ background: '#fff3cd', color: '#856404', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', textTransform: 'uppercase' }}>
                                                {game.Status}
                                            </span>
                                        </td>
                                        <td style={tdStyle}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                <input
                                                    type="number"
                                                    id={`drop-bonus-${game._id}`}
                                                    style={inputStyle}
                                                    placeholder="Bonus"
                                                    defaultValue="50"
                                                />
                                                <select id={`drop-type-${game._id}`} style={selectStyle} defaultValue="running">
                                                    <option value="running">Running</option>
                                                    <option value="cancelled">Cancelled</option>
                                                </select>
                                                <button
                                                    onClick={() => update(game._id)}
                                                    style={{ background: '#57155a', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '6px', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}
                                                >
                                                    UPDATE
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ ...tdStyle, padding: '100px', color: '#999' }}>No drop challenges found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {totalPages > 1 && (
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                    <style>{`
                        .pagination { display: flex; list-style: none; gap: 5px; }
                        .page-item { border: 1px solid #ddd; border-radius: 8px; background: #fff; }
                        .page-link { padding: 10px 15px; color: #000; cursor: pointer; display: block; font-weight: bold; text-decoration: none; }
                        .pagination .active { background: #d63031 !important; color: #fff !important; border-color: #d63031; }
                        .pagination .active a { color: #fff !important; }
                    `}</style>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        pageCount={totalPages}
                        onPageChange={(data) => Allchallenge(data.selected + 1, limit, search)}
                        forcePage={pageNumber > 0 ? pageNumber - 1 : 0}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                    />
                </div>
            )}
        </div>
    )
}
